import React from 'react';
import { object, bool } from 'prop-types';
import classNames from 'classnames';
import { Base } from '@fiverr-private/modal/src';
import { Icon } from '@fiverr-private/fit';
import { s_play_circle } from '@fiverr-private/fit/icons';
import listingsTracker from '../../../../apps/listings/service/tracker';
import categoryTracker from '../../../../apps/categories/service/tracker';
import './index.scss';
import ModalBody from '../ModalBody';
import { GENERAL_VIDEO_MODAL_NAME, VIDEO_PROP_TYPES } from '../constants';

const ExplanationVideo = ({
    hasVideoLink = false,
    subcat = {},
    isCategoryPage = false,
    video,
    videoTitle,
    sourceInfo
}) => {

    const tracker = isCategoryPage ? categoryTracker : listingsTracker;

    const onOpen = () => {
        const { categoryName, title } = subcat;
        tracker.trackHowFiverrWorksVideo({ categoryName, subcategoryName: title });
    };

    const playBtnClass = classNames('btn-play', { 'separated-video-link': hasVideoLink });

    return (
        <div className="explanation-video">
            {subcat.subtitle && <p>{subcat.subtitle}</p>}
            <Base name={GENERAL_VIDEO_MODAL_NAME}
                onOpen={onOpen}
                trigger={({ open }) => (
                    <button className={playBtnClass} onClick={open}>
                        <Icon size={14} className="play-icon">{s_play_circle}</Icon>
                        {videoTitle}
                    </button>)}>
                {() => <ModalBody video={video} sourceInfo={sourceInfo}/>}
            </Base>
        </div>
    );
};

ExplanationVideo.propTypes = {
    ...VIDEO_PROP_TYPES,
    subcat: object,
    hasVideoLink: bool,
    isCategoryPage: bool
};

export default ExplanationVideo;
